export default __webpack_public_path__ + "static/explaining-story-4c6f50dd23bd0ba2afd49d012740b298.svg";